export enum ClientStatus {
  firstInstance = "firstInstance",
  firstInstanceObjection = "firstInstanceObjection",
  secondInstance = "secondInstance",
  secondInstanceObjection = "secondInstanceObjection",
  subsidiaryProtection = "subsidiaryProtection",
  asylum = "asylum",
  noRightOfResidence = "noRightOfResidence",
  expelled = "expelled",
}
